export default __webpack_public_path__ + "locales/pl/SendInviteDialog.json?hash=9be7d0b6fca964828c186ab371daabc9";